(function ($, Drupal) {
    'use strict';
    /**
     * @type {{attach: Drupal.behaviors.accordionHashtag.attach}}
     */
    Drupal.behaviors.accordionHashtag = {
        attach: function (context, settings) {
            var $accordionSection = $(context).find(window.location.hash);
            if ($accordionSection.length) {
                let accordion = $accordionSection.find(".accordion-item");
                accordion.addClass("is-active");
                accordion.find("a").attr("aria-expanded", "true");
                accordion.find(".accordion-content").attr("aria-hidden", "false").show();
                setTimeout(() => {
                    window.scrollTo({
                        top: $accordionSection.offset().top - ($("header").height() + 50),
                        behavior: 'smooth'
                    });
                }, 2000);
            }
        }
    };
})(jQuery, Drupal);
